import request from "@/utils/request";
// 获取系统日志
export function getOperateLog(data) {
  return request({
    url: "local_exam_system_search_log",
    method: "GET",
    params: data,
  });
}
// 获取系统概况
export function getSysSituation(data) {
  return request({
    url: "local_exam_system_statistics",
    method: "GET",
    params: data,
  });
}
